import { render, staticRenderFns } from "./AjanlatAdatokB11_V0.vue?vue&type=template&id=2f22c876&"
import script from "./AjanlatAdatokB11_V0.vue?vue&type=script&lang=js&"
export * from "./AjanlatAdatokB11_V0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports